<template>
  <a-config-provider :locale="locale" class="antialiased">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import dayjs from 'dayjs'
import moment from 'moment'
import 'moment/locale/zh-cn'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')

moment.locale('zh-cn')

export default {
  name: 'App',
  data() {
    return {
      locale: zh_CN
    }
  }
}
</script>
